import { platformNav } from '@/router/rotas';
import { ShellDoProduto } from './ShellDoProduto';

export function PlatformShell() {
    return <ShellDoProduto nav={platformNav} />;
}
